import {
  TeamSelectorFormFieldDocument,
  TeamSelectorFormFieldQuery,
} from 'generated/resources/graphql'

import {
  createGraphqlDataSourceDefinition,
  useGraphqlDataSource,
} from 'modules/core/hooks/useGraphqlDataSource'

export type TeamRecord = {
  id: number
  name: string
}

const teamSelectorSourceDefinition = createGraphqlDataSourceDefinition({
  document: TeamSelectorFormFieldDocument,
  paginationType: 'infinite-scroll',
  perPage: 20,
  mapVariables: ({ search }) => ({
    search: search || undefined,
  }),
  mapData: (data: TeamSelectorFormFieldQuery): TeamRecord[] =>
    data.teams?.teamsConnection?.edges?.map((edge) => ({
      id: edge.node.id,
      name: edge.node.name,
    })) ?? [],
  mapPagination: (data: TeamSelectorFormFieldQuery) => ({
    total: data.teams?.teamsConnection?.totalCount ?? 0,
    cursor: data.teams?.teamsConnection?.pageInfo?.endCursor ?? undefined,
    hasNextPage: data.teams?.teamsConnection?.pageInfo?.hasNextPage ?? false,
  }),
})

export const useTeamSelectorSource = () => {
  return useGraphqlDataSource(teamSelectorSourceDefinition)
}
